import React from "react";

import { OnlineLink } from "components";
import { AgentOfficePartnerTypes } from "types";

import styles from "../search.module.scss";

export const agentOfficeResultItem = (obj): { [key: string]: any } => {
	return (
		<div className={styles.wrappSearchInfo}>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Name:</p>
					<p className={styles.content}>
						<OnlineLink
							to={`/system-setup/agent-office-setup/edit-agent-office/${obj.id}`}
							target="_blank"
						>
							{obj.name}
						</OnlineLink>
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Parent Agent Office:</p>
					{obj.parentOfficeId && (
						<p className={styles.content}>
							<OnlineLink
								to={`/system-setup/agent-office-setup/edit-agent-office/${obj.parentOfficeId}/general-info`}
								target="_blank"
							>
								{obj.parentOfficeName}
							</OnlineLink>
						</p>
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Primary Contact:</p>
					<p className={styles.content} style={{ width: "105px" }}>
						{obj.primaryContact}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Partner Type:</p>
					<p className={styles.content}>
						{AgentOfficePartnerTypes.getDisplayName(
							obj.partnerType,
						)}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent/ Partner Status:</p>
					<p className={styles.content}>{obj.status?.displayName}</p>
				</div>
			}
		</div>
	);
};
